import {PlayerReduxState} from "../types";

export default function isInitAgentActionPlaybackActive(state: PlayerReduxState): boolean {
  const initAgentAction = state.initAgentAction;

  if (!initAgentAction || initAgentAction.played || !initAgentAction.url) {
    return false;
  }

  return state.isRecognizing;
}
